import './styles.scss';
import BenefitCard from './BenefitCard';

const BenefitsBox = ({ title, data, children = <></> }) => (
    <div className="box">
        <h3>{title}</h3>
        <div className="benefits-container">
            {data.map((item, index) => (
                <BenefitCard key={index} item={item} index={index} />
            ))}
        </div>
        {children}
    </div>
);

export default BenefitsBox;
